import { jsx as _jsx } from "react/jsx-runtime";
import { get, useFormContext } from 'react-hook-form';
import { Icon } from '@iconify-icon/react';
import { MultiSelect } from '@mantine/core';
import { useDidUpdate } from '@mantine/hooks';
import { cn } from '@monorepo/utils';
const ControlledMultiSelect = ({ name, readOnly, ...props }) => {
    // Try to get form context, but handle SSR gracefully
    let ctx;
    try {
        ctx = useFormContext();
    }
    catch (e) {
        ctx = null;
    }
    if (!ctx) {
        if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
            console.warn(`ControlledMultiSelect "${name}" must be used inside a <FormProvider>. Rendering uncontrolled fallback.`);
        }
        return _jsx(MultiSelect, { ...props, readOnly: readOnly });
    }
    const { register, formState: { errors, isLoading, isSubmitting }, watch, setValue, trigger, } = ctx;
    const value = watch(name);
    useDidUpdate(() => {
        if (get(errors, name)?.message || value === null) {
            trigger(name);
        }
    }, [value]);
    return (_jsx(MultiSelect, { ...register(name), rightSection: _jsx(Icon, { icon: "tabler:chevron-down", className: "text-gray-800" }), value: Array.isArray(value) ? value : [], onChange: (val) => setValue(name, val), error: get(errors, name)?.message, "aria-invalid": !!get(errors, name), readOnly: readOnly || isLoading || isSubmitting, ...props, classNames: {
            ...props.classNames,
            label: 'text-sm text-gray-800 font-medium mb-1',
            input: cn('h-11 rounded-lg border border-gray-300 placeholder:font-normal', props.classNames?.input),
        } }));
};
export default ControlledMultiSelect;
